module.exports = __webpack_public_path__ + "img/mistakesText14.1bb6c9b2.png";